<template>
    <div class="settings">
        <!--<el-dropdown trigger="click" :hide-on-click="false">-->
            <!--<div class="notification__item el-dropdown-link">-->
                <!--<el-badge :value="0" hidden class="item">-->
                    <!--<el-button size="small" circle>-->
                        <!--<font-awesome-icon icon="cog"/>-->
                    <!--</el-button>-->
                <!--</el-badge>-->
            <!--</div>-->
            <!--<el-dropdown-menu slot="dropdown">-->
                <!--<el-dropdown-item>-->
                    <!--<el-dropdown trigger="click">-->
                        <!--<span class="el-dropdown-link">-->
                            <!--Company<i class="el-icon-arrow-down el-icon&#45;&#45;right"></i>-->
                        <!--</span>-->
                        <!--<el-dropdown-menu slot="dropdown">-->
                            <!--<router-link :to="`/my-companies?companyId=${this.$route.query.companyId}`">-->
                                <!--<el-dropdown-item>Companies</el-dropdown-item>-->
                            <!--</router-link>-->
                            <!--<router-link :to="`/business-centers?companyId=${this.$route.query.companyId}`">-->
                                <!--<el-dropdown-item>Business Centers</el-dropdown-item>-->
                            <!--</router-link>-->
                            <!--<router-link :to="`/add-businessUnits?companyId=${this.$route.query.companyId}`">-->
                                <!--<el-dropdown-item>BusinessUnits</el-dropdown-item>-->
                            <!--</router-link>-->
                            <!--<router-link :to="`/my-regions?companyId=${this.$route.query.companyId}`">-->
                                <!--<el-dropdown-item>Regions</el-dropdown-item>-->
                            <!--</router-link>-->
                            <!--&lt;!&ndash; <el-dropdown-item>-->
                                <!--<div @click="openTemplateProject()">Templates Project</div>-->
                            <!--</el-dropdown-item>-->
                            <!--<el-dropdown-item>-->
                                <!--<div @click="openTemplateBusinessUnit()">Templates BusinessUnit</div>-->
                            <!--</el-dropdown-item> &ndash;&gt;-->
                        <!--</el-dropdown-menu>-->
                    <!--</el-dropdown>-->
                <!--</el-dropdown-item>-->
                <!--<el-dropdown-item><span  @click="showModalCreateCompany" >Add Company</span></el-dropdown-item>-->
                <!--<router-link :to="`/permissions?companyId=${this.$route.query.companyId}`">-->
                <!--<el-dropdown-item >Permissions</el-dropdown-item>-->
                <!--</router-link>-->
                <!--<el-dropdown-item>-->
                    <!--&lt;!&ndash; Task Tree's &ndash;&gt;-->
                    <!--<el-dropdown trigger="click">-->
                        <!--<span class="el-dropdown-link">-->
                            <!--Task Tree's<i class="el-icon-arrow-down el-icon&#45;&#45;right"></i>-->
                        <!--</span>-->
                        <!--<el-dropdown-menu slot="dropdown">-->
                            <!--<el-dropdown-item>-->
                                <!--<div @click="openTemplateProject()">Project Templates</div>-->
                            <!--</el-dropdown-item>-->
                            <!--<el-dropdown-item>-->
                                <!--<div @click="openTemplateBusinessUnit()">BusinessUnit Templates</div>-->
                            <!--</el-dropdown-item>-->
                        <!--</el-dropdown-menu>-->
                    <!--</el-dropdown>-->
                <!--</el-dropdown-item>-->
                <!--<el-dropdown-item>Document MGT</el-dropdown-item>-->
                <!--<el-dropdown-item>Email MGT</el-dropdown-item>-->
                <!--<el-dropdown-item>-->
                    <!--<div @click="openWorkDay()">Work Day</div>-->
                <!--</el-dropdown-item>-->
            <!--</el-dropdown-menu>-->
        <!--</el-dropdown>-->

        <div class="notification__item">
            <el-button @click="goToSettings" size="small">
                <!-- <font-awesome-icon icon="cog"/> -->
                <img src="@/assets/img/toolbar/settings.svg" width="18px" alt="">
            </el-button>
        </div>

        <!-- <el-menu  class="el-menu-demo" mode="horizontal">
            <el-submenu popper-class="title-head" index="2">
                <template  slot="title">
                    <el-badge :value="0" hidden class="item">
                        <el-button @click="goToSettings" size="small" circle>
                            <font-awesome-icon icon="cog"/>
                        </el-button>
                    </el-badge>
                </template>
                <el-submenu popper-class="title-head-second" index="2-4">
                    <template slot="title">
                        Company
                    </template>
                    <el-submenu popper-class="title-head-second" index="2-4-1">
                            <template slot="title">
                            <router-link :to="`/my-companies?companyId=${this.$route.query.companyId}`">
                                <el-dropdown-item>Companies</el-dropdown-item>
                            </router-link>
                            </template>
                            <el-menu-item index="2-4-1-1">
                                <router-link :to="`/settings?companyId=${this.$route.query.companyId}`">
                                    <el-dropdown-item>Settings</el-dropdown-item>
                                </router-link>
                            </el-menu-item>
                </el-submenu>
                    <el-menu-item index="2-4-2">
                        <router-link :to="`/business-centers?companyId=${this.$route.query.companyId}`">
                        <el-dropdown-item>Business Centers</el-dropdown-item>
                        </router-link>
                    </el-menu-item>
                    <el-menu-item index="2-4-3">
                        <router-link :to="`/add-business-units?companyId=${this.$route.query.companyId}`">
                        <el-dropdown-item>Business Units</el-dropdown-item>
                        </router-link>
                    </el-menu-item>
                    <el-menu-item index="2-4-4">
                        <router-link :to="`/my-regions?companyId=${this.$route.query.companyId}`">
                        <el-dropdown-item>Regions</el-dropdown-item>
                        </router-link>
                    </el-menu-item>
                </el-submenu>
                <el-menu-item index="2-2">
                    <router-link :to="`/permissions?companyId=${this.$route.query.companyId}`">
                        <el-dropdown-item class="link">Permissions</div>
                    </router-link>
                </el-menu-item>
                <el-submenu popper-class="title-head-second" index="2-5">
                    <template slot="title">
                        Task Tree
                    </template>
                    <el-menu-item index="2-5-1">
                            <el-dropdown-item>
                                <div @click="openTemplateProject()">Project Templates</div>
                            </el-dropdown-item>
                    </el-menu-item>
                    <el-menu-item index="2-5-2">
                        <el-dropdown-item>
                        <div @click="openTemplateBusinessUnit()">Business Unit Templates</div>
                        </el-dropdown-item>
                    </el-menu-item>
                    <el-menu-item index="2-5-3">
                        <el-dropdown-item>
                            <div @click="openTemplateEngagement()">Engagement Templates</div>
                        </el-dropdown-item>
                    </el-menu-item>
                </el-submenu>
                <el-menu-item index="2-3">
                    <div>Document MGT</div>
                </el-menu-item>
                <el-menu-item index="2-6">
                    <div>Email MGT</div>
                </el-menu-item>
                <el-menu-item index="2-7">
                    <div @click="openWorkDay()">Billable</div>
                </el-menu-item>
            </el-submenu>
        </el-menu> -->

        <sweet-modal ref="company" class="modal" v-on:close="closeModal">
            <h1>Add Company</h1>

            <el-form :model="form" status-icon :rules="rules" ref="form" label-width="0" class="demo-ruleForm">
                <el-form-item prop="companyName">
                    <el-input placeholder="Company name" v-model="form.companyName"></el-input>
                </el-form-item>

                <el-form-item prop="email">
                    <el-input v-model="form.email" placeholder="Email"></el-input>
                </el-form-item>

                <!-- <el-form-item prop="currencyCode">
                    <el-input v-model="form.currencyCode" placeholder="Сurrency Company"></el-input>
                </el-form-item> -->

                <el-form-item prop="currencyCode">
                   <el-select v-model="form.currencyCode" placeholder="Сurrency Company" filterable>
                        <el-option v-for="item in currencyList"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>

                <el-form-item>
                    <el-button @click="submitForm('form')" class="modal__btn" type="primary" plain size="small">Create</el-button>
                </el-form-item>
            </el-form>
        </sweet-modal>
        <sweet-modal class="addSuccess" id="addSuccess" ref="addSuccess" icon="success">
            Congratulation,<br>
            Company successfully created, you can now select it from your company list.
        </sweet-modal>

        <!-- [ Modal form Template Project ] start -->
        <TemplatesProject ref="modal"/>
        <!-- [ Modal form Template Project ] end -->

        <!-- [ Modal form Template BusinessUnit ] start -->
        <TemplatesBusinessUnit ref="modal1"/>
        <!-- [ Modal form Template BusinessUnit ] end -->
        <!-- [ Modal form Template BusinessUnit ] start -->
        <TemplatesEngagement ref="modal2"/>
        <!-- [ Modal form Template BusinessUnit ] end -->
    </div>
</template>

<script>
    import TemplatesProject from '@/components/notifications/templates/TemplatesProject.vue'
    import TemplatesBusinessUnit from '@/components/notifications/templates/TemplatesBusinessUnit.vue'
    import TemplatesEngagement from '@/components/notifications/templates/TemplatesEngagement.vue'
    import { SweetModal } from '@totalflow4/tfsweet-modal-vue'
    import axios from 'axios'
    export default {
        components: {
            SweetModal,

            TemplatesProject,
            TemplatesBusinessUnit,
            TemplatesEngagement
        },
        data() {
            return{
                currencyList: [],
                form: {
                    companyName: '',
                    email: '',
                    currencyCode: '',
                },
                rules: {
                    companyName: [
                        { required: true, message: 'Please input Activity Company name', trigger: 'blur' },
                        { min: 5, message: 'Length should be 5', trigger: 'blur' }
                    ],
                    email: [
                        { required: true, message: 'Please input Email address', trigger: 'blur' },
                        { type: 'email', message: 'Please input correct email address', trigger: 'blur' }
                    ],
                    currencyCode: [{
                      required: true,
                      message: 'Currency Code is required',
                      trigger: 'blur'
                    }],
                }
            }
        },
        methods:{
          goToSettings(){
            this.$router.push({ name: 'settings', query: { companyId: this.$route.query.companyId } })
          },
              handleSelect(key, keyPath){
                alert(key, keyPath)
              },
            showModalCreateCompany() {
                console.log('---', 'open');

                axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
                axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
                axios
                    .post(`/api/v1/companies/directories?operation=create`)
                    .then(response => {
                        console.log('---/companies/directories', response.data.currencyList);
                        this.currencyList = response.data.currencyList
                        this.$refs.company.open()
                    })
                    .catch(error => {
                        console.log('An error occurred:', error);
                    });
            },
            submitForm(form) {
                this.$refs[form].validate((valid) => {
                    if (valid) {
                        let loader = this.$loading.show();
                        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
                        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
                        axios
                            .post('/api/v1/companies/create', {
                                name: this.form.companyName,
                                email: this.form.email,
                                currencyId: this.form.currencyCode,
                            })
                            .then(response => {
                                console.log('---', response.data);
                                this.$refs.company.close();
                                // this.notification("Success", "Create company", "success");
                              this.$refs.addSuccess.open();
                              setTimeout(() => {
                                this.$refs.addSuccess.close();
                              }, 4000);
                                this.$store.dispatch('loadUser')
                                loader.hide()
                            })
                            .catch(error => {
                                console.log('An error occurred:', error);
                                loader.hide()
                            });
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });
            },
            openTemplateProject() {
                this.$refs['modal'].$refs['template'].open()
                this.$store.dispatch('getTemplatesProject')
            },
            openTemplateBusinessUnit() {
                this.$refs['modal1'].$refs['template'].open()
                this.$store.dispatch('getTemplatesBusinessUnit')
            },
          openTemplateEngagement() {
            this.$refs['modal2'].$refs['template'].open()
            this.$store.dispatch('getTemplatesEngagement')
          },
            // openWorkDay() {
            //     this.$store.dispatch('getInvoicesList', this.$route.query.projectId)
            //     this.$router.push(`/invoices?companyId=${this.$route.query.companyId}`);
            // },
            closeModal(){
                this.$refs['form'].resetFields()
            },
            notification(title, message, type) {
                this.$notify({
                    title: title,
                    message: message,
                    type: type
                });
            },
        }
    }
</script>

<style lang="less" scoped>
    .notification__item {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 35px;
        height: 35px;
        color: white;
        border-radius: 3px;
        margin-right: 3px;
        cursor: pointer;
    }
    /deep/.el-button--small, .el-button--small.is-round {
        padding: 5px 5px;
    }
    .settings{
        height:35px;
    }
    .modal {
        color: black;
        .modal__btn {
            margin-top: 20px;
        }
    }
    #addSuccess{
         display:flex;
         justify-content: center !important;
         text-align: center !important;
         color: black;
    }
</style>

<style lang="less">
    .el-menu-demo{
        background-color: transparent !important;
        border: 0 !important;
        .el-submenu{
            border:0;
            .el-menu-item{
                padding: 0 !important;
            }
            .el-submenu__title{
                padding:0 !important;
                height: 100% !important;
                border: 0 !important;
                .el-badge{
                    display:flex;
                }
                .el-submenu__icon-arrow{
                    display:none;
                }
                &:hover{
                    background-color: transparent !important;
                }
            }
        }
        .el-submenu:last-child{
            border:0;
        }
    }
    .link{
        color:#909399 !important;
    }
    .title-head{
        top: 46px !important;
        border: 1px solid #ebeef5;
        box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
        margin-top:5px !important;
        border-radius:4px;
        .el-menu{
            margin-top:0;
            padding: 0;
            li:first-child{
                border-radius:4px;
            }
            li:last-child{
                border-radius:4px;
            }
            li:hover{
                outline: none;
                background-color: #ecf5ff;
            }
        }
        .el-submenu{
            .el-submenu__title{
                border-radius:4px;
                padding: 0 10px !important;
                .el-submenu__icon-arrow{
                    display:block;
                }
                &:hover{
                    outline: none;
                    background-color: #ecf5ff !important;
                }
            }
            &:hover{
                outline: none;
                background-color: #ecf5ff;
            }
        }
    }
</style>
